export default __webpack_public_path__ + "static/media/ion_sparkles-outline.c2a7cce4.svg";